import Graphs from '../Graphs';
import { scaleLinear, scaleBand, scaleOrdinal } from 'd3-scale';
import { max, range } from 'd3-array';
import { select, mouse } from 'd3-selection';
import { transition } from 'd3-transition';
import { axisLeft, axisBottom } from 'd3-axis';
import { area, line, curveCardinal } from 'd3-shape';
import { format } from 'd3-format';

import './AreaGraph.css';

export default class AreaGraph extends Graphs {
  renderChart = () => {
    this.setState({className: "AreaGraph"});
    global.transition = transition;
    const node = this.node;
    const padding = max(this.props.size) / 20;
    const g = select(node)
      .append('g')

    const data = [].concat(this.props.data).sort((a, b) => max(b.map(item => item.value)) - max(a.map(item => item.value)))

    const x = scaleBand()
			.range([padding, this.props.size[0] - padding])
      .padding(0.5)
      .domain(data.length ? data[0].map(item => item.key) : [])

    const y = scaleLinear()
      .rangeRound([this.props.size[1] - padding, padding])
      .domain([0, max(data.reduce((acc, curr) => [...acc, ...curr], []).map(item => item.value))]);

    const z = scaleOrdinal(this.props.colorScheme)
      .domain(range(data.length))

    const makeXgridlines = () => axisBottom(x).ticks(5)

    const makeYgridlines = () => axisLeft(y).ticks(5)

    g
      .append('g')
      .attr("class", "grid")
      .attr("transform", `translate(${-padding}, ${this.props.size[1] - padding / 2})`)
      .call(makeXgridlines()
        .tickSize(-this.props.size[1])
        .tickFormat("")
      )

    g
      .append('g')
      .attr("class", "grid")
      .attr("transform", `translate(${padding}, ${-padding / 2})`)
      .call(makeYgridlines()
        .tickSize(-this.props.size[0] + padding + x.bandwidth())
        .tickFormat("")
      )

    g
      .append("g")
      .attr("transform", `translate(${-x.bandwidth()}, ${this.props.size[1] - padding / 2})`)
      .attr("class", "x-axis")
      .call(axisBottom(x).tickSize(0).tickValues(x.domain().filter((d, i, arr) => (!(i%4) || arr.length < 12))));

    g
      .append("g")
      .attr("transform", `translate(${padding}, ${padding / 2})`)
      .attr("class", "y-axis")
      .call(axisLeft(y).tickSize(0).tickFormat(format(".3s")));

    data.forEach((item, idx) => {
      const areaInst = area()
        .x(d => x(d.key))
        .y1(d => y(d.value))
        .y0(y(0))
        .curve(curveCardinal.tension(0));

      const lineInst = line()
        .x(d => x(d.key))
        .y(d => y(d.value))
        .curve(curveCardinal.tension(0));

      const lineBorder = line()
        .x(d => x(d.key))
        .y(d => y(d.value) + 1)
        .curve(curveCardinal.tension(0));

      g
        .append('path')
        .datum(item)
        .attr("transform", `translate(${-x.bandwidth()}, ${padding / 2})`)
        .attr("d", areaInst)
        .on('mouseover', function() {
          return select(this)
            .attr('fill', 'teal')
            .attr("opacity", "0.8");
        })
        .on('mouseout', function(d) {
          return select(this)
            .transition()
            .duration(200)
            .attr("fill", z(idx))
            .attr("opacity", "0.5")
        })
        .attr("fill", "none")
        .attr("opacity", "0")
        .transition()
        .delay(300*idx)
        .duration(1000)
        .attr("fill", z(idx))
        .attr("opacity", "0.5")

      g
        .append('path')
        .datum(item)
        .attr("d", lineBorder)
        .attr("transform", `translate(${-x.bandwidth()}, ${padding / 2})`)
        .style("stroke", "#fff")
        .attr("fill", "none")
        .style("stroke-width", "0.5px")

      const linePath = g
        .append('path')
        .datum(item)
        .attr("d", lineInst)
        .style("stroke", z(idx))
        .attr("transform", `translate(${-x.bandwidth()}, ${padding / 2})`)
        .attr("fill", "none")
        .style("stroke-width", "1px")
        .style("stroke-linecap", "round")

      const lineLength = linePath.node().getTotalLength();

      linePath
        .attr("stroke-dasharray", `${lineLength} ${lineLength}`)
        .attr("stroke-dashoffset", lineLength)
        .transition()
        .delay(200*idx)
        .duration(1000)
        .attr("stroke-dashoffset", 0);

      g
        .selectAll('.dot')
        .data(item)
        .enter()
        .append('circle')
        .attr("r", 2.5)
        .attr("cx", d => x(d.key))
        .attr("cy", d => y(d.value))
        .attr("fill", this.props.colorScheme[0])
        .attr("transform", `translate(${-x.bandwidth()}, ${padding / 2})`)
        .on('mouseover', function(d) {
          tooltip.style("display", null);
          select(this)
            .transition()
            .attr("r", 10)
        })
        .on('mouseout', function() {
          tooltip.style("display", "none");
          select(this)
            .transition()
            .attr("r", 2.5)
        })
        .on("mousemove", function(d) {
          var xPosition = mouse(this)[0] - 5;
          var yPosition = mouse(this)[1] - 5;
          tooltip.attr("transform", `translate(${xPosition-40}, ${yPosition})`);
          tooltip
            .select("text")
            .text(`${d.key}: ${format('0.3s')(d.value)}`)
            .attr("transform", `translate(${-20},0)`)
          tooltip
            .select('rect')
            .attr('width', () => tooltip.select('text').node().getComputedTextLength()+20)
            .attr('transform', `translate(${-30-tooltip.select('text').node().getComputedTextLength()/16}, 0)`)
        });

      const tooltip = select(node).append("g")
        .attr("class", "tooltip")
        .style("display", "none");

      tooltip.append("rect")
        .attr("width", '20')
        .attr("height", 20)
        .attr("fill", "#333");

      tooltip.append("text")
        .attr("x", 30)
        .attr("dy", "1.2em")
        .style("text-anchor", "middle")
        .attr("font-size", "0.5em")
        .attr("fill", "#fff")

    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Graphs/AreaGraphComponent/AreaGraph.js